import { useState, useEffect } from "react";

// Animated Counter Component
// FIX 2026-05-24: Default count is `end` (final value) not 0.
// Reason: Headless browsers / SEO-bots / Meta-crawler don't trigger
// IntersectionObserver → shouldAnimate stays false → previously count stayed 0
// → "Vertrauen durch Zahlen" Sektion zeigte 0/0/0/0 für ALLE Bots (Trust-Killer)
// Now: Default render = final value (bot-friendly). User mit scroll bekommt Animation.
const AnimatedCounter = ({
  end,
  suffix = "",
  prefix = "",
  duration = 2000,
  shouldAnimate = false,
  decimals = 0,
}) => {
  // Start with the END value so bots/crawlers see real numbers.
  // Animation will reset to 0 and count up only when shouldAnimate=true.
  const initialDisplay = decimals > 0 ? end.toFixed(decimals) : Math.floor(end);
  const [count, setCount] = useState(initialDisplay);

  useEffect(() => {
    if (!shouldAnimate) {
      // Keep showing final value (no animation triggered yet, e.g. for bots)
      return;
    }

    // User is now in view — animate from 0 to end
    setCount(0);
    let startTime;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = progress * end;
      setCount(
        decimals > 0 ? currentValue.toFixed(decimals) : Math.floor(currentValue)
      );
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [end, duration, shouldAnimate, decimals]);

  return (
    <span className="text-4xl lg:text-5xl font-bold text-[#C5A66A]">
      {prefix}
      {count}
      {suffix}
    </span>
  );
};

export default AnimatedCounter;
